import actions from '../../actionTypes';

export default (siteId, workflowId) => {
  return {
    type: actions.GET_TRIGGERS,
    siteId,
    workflowId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/triggers/actions/getTriggers.js